import { createRoute, Outlet, redirect } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { sessionActor } from "@/lib/session-machine";

export const adminRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/admin",
  beforeLoad: () => {
    const snapshot = sessionActor.getSnapshot();

    // In TanStack Router beforeLoad, we can check the current session
    // Since _app/route.tsx already prefetched/primed it, it should be available.
    const { session } = snapshot.context;

    if (session?.user.role !== "admin") {
      // Not an admin — redirect to profile (matching native behavior)
      // oxlint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: "/profile" });
    }
  },
  component: () => <Outlet />,
});
